module.exports = __webpack_public_path__ + "img/icon-plus.bf5975b1.svg";